<!-- 由 suu 创建于 2022-06-22 Wednesday -->
<!-- 问卷 -->
<template>
  <div class="recipe-cna-ques">
    <!-- 步骤 -->
    <ques-steps
      v-if="total"
      class="cna-steps"
      :current="current"
      :curQuetionIndex="curQuetionIndex"
      :total="total"
      @prestep="handelPreStep"
    ></ques-steps>
    <div class="cna-conten">
      <!-- 目录 -->
      <ques-contents
        v-if="showClass"
        :active="classIndex"
        :list="questionData"
      ></ques-contents>
      <!-- 题目 -->
      <template v-if="showQuestion">
        <!-- 单选 -->
        <template v-if="selectData.field_type == 'radio'">
          <!-- 性别 -->
          <ques-gender
            v-if="selectData.field == 'sex'"
            :curQues="selectData"
            @change="handelRadioChange"
          ></ques-gender>
          <!-- 单选 -->
          <ques-radio
            v-else
            :curQues="selectData"
            @change="handelRadioChange"
          ></ques-radio>
        </template>
        <!-- 多选 -->
        <ques-checkbox
          v-if="selectData.field_type == 'checkbox'"
          :curQues="selectData"
          @change="handelCheckboxChange"
        ></ques-checkbox>
        <!-- 输入 -->
        <ques-input
          v-if="
            selectData.field_type == 'int' || selectData.field_type == 'string'
          "
          :type="selectData.field"
          :inputType="selectData.field_type"
          :curQues="selectData"
          @change="handelInputChange"
        ></ques-input>
        <!-- 日期 -->
        <ques-date
          v-if="selectData.field_type == 'date'"
          :curQues="selectData"
          @change="handelDateChange"
        ></ques-date>
      </template>
      <!-- 按钮 -->
      <div class="next-step-region" v-if="finish || showNextBtn">
        <div class="next-step user-btn" v-if="finish" @click="submitInfo"
          >提交</div
        >
        <div
          v-else-if="
            !hideBtn.includes(selectData.field_type) || selectData.value
          "
          :class="{ 'next-step user-btn': true, 'disable-step': disabledStep }"
          @click="handelNextStepClick"
        >
          <span>{{
            selectData.field_type == 'checkbox' &&
            (!selectData.value || !selectData.value.length)
              ? '均无'
              : '确定'
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import quesSteps from './ponents/ques-steps.vue'
import quesContents from './ponents/ques-contents.vue'
import quesGender from './ponents/ques-gender.vue'
import quesRadio from './ponents/ques-radio.vue'
import quesCheckbox from './ponents/ques-checkbox.vue'
import quesInput from './ponents/ques-input.vue'
import quesDate from './ponents/ques-date.vue'
export default {
  name: 'recipe-cna-ques',

  components: {
    quesSteps,
    quesContents,
    quesGender,
    quesRadio,
    quesInput,
    quesDate,
    quesCheckbox
  },

  props: {},

  data() {
    return {
      current: 0, //当前是第几个问题
      finish: false, //是否完成问卷
      showClass: true, //是否显示大类
      showQuestion: false, //是否显示问题
      classIndex: 0, //目前处于第几大类
      curQuetionIndex: 0, //当前问题在 当前目录的列表中的序号
      questionData: [], //问卷所有题目
      selectData: [], //当前问题的所有选项数据
      disabledStep: false, //是否禁用下一步

      hideBtn: ['int', 'string', 'date']
    }
  },

  computed: {
    rid() {
      return this.$route.query.id
    },
    // 显示下一步按钮
    showNextBtn() {
      return (
        !this.finish &&
        ['checkbox', 'int', 'string', 'date'].includes(
          this.selectData.field_type
        )
      )
    },
    //去掉非必填项的总题目
    total() {
      //计算题目总数
      let total = 0
      this.questionData.map((item) => {
        total += item.sub_list.length
      })
      return total
    }
  },

  watch: {
    classIndex(nv) {
      this.questionData[nv] &&
        (document.title = this.questionData[nv]['sub_title'])
    }
  },

  created() {
    this.getQuestionList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 保存数据
     */
    submitInfo() {
      this.$toast.loading('加载中...')
      this.$http
        .postBaseApp('member/AppCamp/posterQuestionSave', {
          info: JSON.stringify(this.questionData),
          type: 8,
          rid: this.rid
        })
        .then((res) => {
          this.$toast.clear()
          res = res.data
          if (res.code == 200) {
            this.$toast('提交成功')
            setTimeout(() => {
              this.$router.replace('/recipe-cna-result?rid=' + this.rid)
            }, 1200)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    bindBack() {
      // wx.miniProgram.redirectTo({url:'/package-recipe/pages/questionnaire/list/index'});
      // app中
      if (this.$betterwe.isApp()) {
        if (this.$route.query.sfrom === 'weVip') {
          window.history.back()
        } else {
          window.history.go(-2)
        }
      } else {
        wx.miniProgram.navigateBack()
      }
    },
    /**
     * 日期
     */
    handelDateChange(value) {
      if (value) {
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 || 0
        ].value = value
        this.disabledStep = false
      }
    },
    /**
     * 输入框
     */
    handelInputChange(obj) {
      let value = obj.value
      this.questionData[this.classIndex].sub_list[
        this.curQuetionIndex - 1 || 0
      ].value = value
      let disabledStep = true
      if (value !== '') {
        disabledStep = false
      }
      //判断bmi 范围进行打分
      if (this.selectData['field'] === 'weight') {
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 || 0
        ].data_num = this.getBmiScore(value)
      }
      this.disabledStep = disabledStep
    },
    /**
     * 计算bmi 对应打分
     */
    getBmiScore(weight) {
      const height = this.questionData[this.classIndex].sub_list.find(
        (v) => v.field === 'height'
      ).value
      const bmi = weight / Math.pow(height / 100, 2)
      if (bmi >= 28) {
        return -15
      } else if (bmi > 24) {
        return -10
      }
      return 0
    },
    /**
     * 多选
     */
    //多选框组件变化时
    handelCheckboxChange(obj) {
      let value = obj.value
      let extra = obj.extra
      let score = obj.score
      let curQues =
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 || 0
        ]
      curQues.value = value
      curQues.extra = extra
      curQues.data_num = score
      //判断是否选中其他选项
      let ischeckExtra = false
      let arr =
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 || 0
        ].field_unit
      arr.map((item, index) => {
        if (item.is_extra) {
          ischeckExtra = value.indexOf(item.key) >= 0 ? true : false
        }
      })
      // 多选 现可以直接跳过 默认
      let disabledStep = false
      if (value !== '' && value.length) {
        if (ischeckExtra) {
          disabledStep = extra ? false : true
        } else {
          disabledStep = false
        }
      }
      this.disabledStep = disabledStep
    },
    /**
     * 单选选项改变
     */
    handelRadioChange(obj) {
      const value = obj.value
      const score = obj.score || ''
      let curQues =
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 || 0
        ]
      curQues.value = value
      curQues.data_num = score
      let hideindex = ''
      let isHide = false
      curQues.field_unit.map((item) => {
        if (item.hideindex) {
          hideindex = item.hideindex
          if (item.key == value) {
            isHide = true
          }
        }
      })
      if (hideindex) {
        this.hideQuestion(hideindex, isHide)
      }
      let disabledStep = true
      if (value !== '') {
        disabledStep = false
      }
      // 判断孕期
      if (curQues.field == 'phase') {
        disabledStep = this.isDisabledStatus(value) //
      }
      this.disabledStep = disabledStep
      setTimeout(() => {
        if (!obj.update) {
          this.handelNextStep()
        }
      }, 150)
    },
    // 跳过选项
    hideQuestion(hideindex, isHide) {
      this.questionData.map((item) => {
        item.sub_list.map((item1) => {
          if (hideindex.includes(item1.index)) {
            item1.hide = isHide
          }
        })
      })
    },
    // 判断是否超过18岁
    getIsAdult(value) {
      value = value.replace(/-/g, '/')
      let birthdayList = value.split('/')
      let adultYear = +birthdayList[0] + 18
      let adultDay = adultYear + '/' + birthdayList[1] + '/' + birthdayList[2]
      let adultTime = new Date(adultDay).getTime()
      let curTime = new Date().getTime()
      return curTime - adultTime > 0 ? true : false
    },
    // 根据女生处于阶段决定是否可以继续填写问卷
    isDisabledStatus(value, update) {
      let arr = [
        {
          name: '孕期',
          tips: '孕期、顺产3个月内、剖腹产6个月内的特殊人群不适用于减脂营内饮食建议，建议您遵医嘱'
        },
        {
          name: '剖腹产6个月内',
          tips: '孕期、顺产3个月内、剖腹产6个月内的特殊人群不适用于减脂营内饮食建议，建议您遵医嘱'
        },
        {
          name: '顺产3个月内',
          tips: '孕期、顺产3个月内、剖腹产6个月内的特殊人群不适用于减脂营内饮食建议，建议您遵医嘱'
        }
      ]
      let tips = arr.find((item) => item.name == value)
      tips && (tips = tips['tips'])
      if (tips && !update) {
        this.$dialog.alert({ message: tips })
        return true
      }
      return tips ? true : false
    },
    /**
     * 获取问卷
     */
    getQuestionList() {
      this.$toast.loading('加载中...')
      this.$http
        .getBaseApp('member/AppCamp/getCNAQuestion', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.questionData = res.data
            this.questionData[0] &&
              (document.title = this.questionData[0]['sub_title'])
            setTimeout(() => {
              this.handelNextStep()
              this.$forceUpdate()
            }, 1200)
          } else {
            this.$toast(res.msg)
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    /**
     * 点击一下步按钮
     */
    handelNextStepClick() {
      // 输入框 延迟
      if (
        this.selectData.field_type == 'int' ||
        this.selectData.field_type == 'string'
      ) {
        setTimeout(() => {
          this.handelNextStep()
        }, 500)
      } else {
        this.handelNextStep()
      }
    },
    /**
     * 下一步
     */
    handelNextStep() {
      if (this.disabledStep) return
      if (
        this.curQuetionIndex <
        this.questionData[this.classIndex].sub_list.length
      ) {
        //如果当前问题类型的index小于当前类型的总数量则加
        this.curQuetionIndex = ++this.curQuetionIndex
        // notQuestion的情况？？
        let notQuestion =
          this.questionData[this.classIndex].sub_list[this.curQuetionIndex - 1]
            .notQuestion
        this.current = notQuestion ? this.current : ++this.current
        this.showClass = false
        this.showQuestion = true
      } else {
        // 当前目录下标+1
        this.classIndex = ++this.classIndex
        this.curQuetionIndex = 0
        // 已完成最后一题
        if (this.classIndex >= this.questionData.length) {
          this.finish = true
        }
        this.showClass = true
        this.showQuestion = false
        // 目录页直接延迟跳转
        if (!this.finish) {
          setTimeout(() => {
            this.handelNextStep()
            this.$forceUpdate()
          }, 1200)
        }
      }
      // 当前目录超过总目录
      if (this.classIndex >= this.questionData.length) {
        return
      }
      // 是否跳过该题
      let hide =
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex < 1 ? 0 : this.curQuetionIndex - 1
        ].hide
      if (hide) {
        this.handelNextStep()
        return
      }
      let cur = this.curQuetionIndex - 1 > 0 ? this.curQuetionIndex - 1 : 0
      let item = this.questionData[this.classIndex].sub_list[cur]
      let disabledStep = false
      //判断是否超过18岁
      // if (item.field == 'birthday' && item.value) {
      //   let isAdult = this.getIsAdult(item.value)
      //   if (!isAdult) {
      //     disabledStep = true
      //   }
      // }
      //根据女生阶段决定是否继续问卷
      if (item.field == 'phase' && item.value) {
        disabledStep = this.isDisabledStatus(item.value)
      }
      if ((item.value === '' || !item.value.length) && this.curQuetionIndex) {
        disabledStep = true
      }
      // 多选默认可选无进入下一题
      if (item.field_type == 'checkbox') {
        disabledStep = false
      }
      this.selectData = item
      this.disabledStep = disabledStep
    },
    /**
     * 上一步
     */
    handelPreStep() {
      // 添加在第一题时 点击返回 返回上页逻辑
      if (this.curQuetionIndex <= 1 && this.current <= 1) {
        this.$router.back()
        wx.miniProgram.navigateBack()

        return
      }
      if (this.curQuetionIndex === 0) {
        return
      }
      // 之前逻辑不动
      if (this.curQuetionIndex > 1) {
        //点击上一步时当前的题目是不是一个题目
        let notQuestion =
          this.questionData[this.classIndex].sub_list[this.curQuetionIndex - 1]
            .notQuestion
        // let preNotQuestion =
        //   this.questionData[this.classIndex].sub_list[this.curQuetionIndex - 2]
        //     .notQuestion
        this.curQuetionIndex = --this.curQuetionIndex
        if (!notQuestion) {
          //this.current = preNotQuestion ? this.current : --this.current;
          this.current = this.current - 1
        }
      } else {
        let notQuestion
        if (this.curQuetionIndex > 0) {
          notQuestion =
            this.questionData[this.classIndex].sub_list[
              this.curQuetionIndex - 1
            ].notQuestion || false
        }
        this.classIndex = --this.classIndex < 0 ? 0 : this.classIndex
        this.curQuetionIndex =
          this.questionData[this.classIndex].sub_list.length
        if (notQuestion === undefined) {
          notQuestion =
            this.questionData[this.classIndex].sub_list[
              this.curQuetionIndex - 1
            ].notQuestion
        }
        // let preNotQuestion =
        //   this.questionData[this.classIndex].sub_list[this.curQuetionIndex - 1]
        //     .notQuestion
        if (this.classIndex >= this.questionData.length - 1) {
          this.current = JSON.parse(JSON.stringify(this.current))
        } else {
          if (!notQuestion) {
            this.current = --this.current
          }
        }
      }
      let hide =
        this.questionData[this.classIndex].sub_list[
          this.curQuetionIndex - 1 < 0 ? 0 : this.curQuetionIndex - 1
        ].hide
      if (hide) {
        this.handelPreStep()
        return
      }
      this.showClass = false
      this.showQuestion = true
      this.finish = false
      let cur = this.curQuetionIndex - 1 > 0 ? this.curQuetionIndex - 1 : 0
      let item = this.questionData[this.classIndex].sub_list[cur]
      let disabledStep = false
      if ((item.value === '' || !item.value.length) && this.curQuetionIndex) {
        disabledStep = true
      }
      // 多选默认可选无进入下一题
      if (item.field_type == 'checkbox') {
        disabledStep = false
      }
      this.selectData = item
      this.disabledStep = disabledStep
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.recipe-cna-ques {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  background-color: #f5f5f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include paddingBottom(114px);

  .cna-steps {
    margin-top: 18px;
  }

  .cna-conten {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 26px;

    .next-step-region {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 142px;
      background: linear-gradient(
        180deg,
        rgba(245, 245, 247, 0.3) 0%,
        rgba(245, 245, 247, 0.8) 30%,
        #f5f5f7 100%
      );
      position: fixed;
      @include fixedBottom();
    }

    .next-step {
      width: 188px;
      height: 50px;
      background: #9890fd;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
    }

    .disable-step {
      filter: grayscale(100%);
    }
  }
}
</style>
